// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__EjjzQ","row":"styles_row__C7pMk"};